import Icon, { IconName } from '@/components/Icon/Icon';
import ResponsiveImage from '@/components/Image/ResponsiveImage';
import Link from '@/components/Link/Link';
import type { FrontifyImageContent } from '@/contentful/contentful-exports';
import useStyles from './HighlightLightbox.styles';

interface HighlightLightboxImageProps {
  thumbnail: [FrontifyImageContent];
  hasVideo: boolean;
  href?: string;
  isOnDark: boolean;
  isPlayButtonOnDark: boolean;
  isRightAligned: boolean;
  mobileOrientation?: 'Image first' | 'Text first';
  onVideoOpen: () => void;
}

export default function HighlightLightboxImage({
  thumbnail,
  hasVideo,
  href,
  isOnDark,
  isPlayButtonOnDark,
  isRightAligned,
  mobileOrientation,
  onVideoOpen,
}: HighlightLightboxImageProps) {
  const { classes } = useStyles({
    isOnDark,
    isPlayButtonOnDark,
    isRightAligned,
    mobileOrientation,
  });

  if (hasVideo) {
    return (
      <button
        type='button'
        className={classes.imageContent}
        aria-label='Open video player'
        onClick={onVideoOpen}
      >
        <div className={classes.svgOverlay}>
          <Icon
            name={IconName.PLAY}
            width={60}
            height={60}
            className={classes.playIcon}
          />
        </div>

        {thumbnail[0] && (
          <ResponsiveImage
            src={thumbnail[0]}
            alt={thumbnail[0].title}
            className={classes.image}
            sizes={{ xs: 544, sm: 896, md: 512 }}
          />
        )}
      </button>
    );
  }

  if (href) {
    return (
      <Link href={href} className={classes.imageContent}>
        {thumbnail[0] && (
          <ResponsiveImage
            src={thumbnail[0]}
            alt={thumbnail[0].title}
            className={classes.image}
            sizes={{ xs: 544, sm: 896, md: 512 }}
          />
        )}
      </Link>
    );
  }

  return (
    <div className={classes.imageContent}>
      {thumbnail[0] && (
        <ResponsiveImage
          src={thumbnail[0]}
          alt={thumbnail[0].title}
          className={classes.image}
          sizes={{ xs: 544, sm: 896, md: 512 }}
        />
      )}
    </div>
  );
}
